<div class="flex justify-center items-center w-full h-full bg-reset-password">
  <div class="w-96 bg-[#fff] shadow-md rounded-lg p-2 move-down">
    <!-- BEGIN: IMAGE DIV -->
    <div class="flex justify-center">
      <div class="rounded-full shadow-2xl border-2 border-gray-200">
        <img
          src="/assets/images/emblem.png"
          class="p-3"
          alt="emblem"
          width="100"
          height="100"
        />
      </div>
    </div>
    <!-- END: IMAGE DIV -->

    <!--BEGIN: HEADING -->
    <div class="text-center mt-1">
      <span class="font-bold text-[#28409A] text-base">
        Tanzania Government Service Directory
      </span>
    </div>
    <!--END: HEADING -->

    <!-- BEGIN: FORM -->
    <div>
      <form [formGroup]="resetPasswordForm" autocomplete="off" novalidate>
        <div class="container-fluid">
          <div class="row my-2 text-center">
            <!--BEGIN: EMAIL FIELD -->
            <div class="col-md-12">
              <mat-form-field appearance="outline" class="material-form">
                <input placeholder="email" formControlName="email" matInput />
                <mat-icon matPrefix svgIcon="email1" class="mx-2"></mat-icon>
              </mat-form-field>
            </div>
            <!--END: EMAIL FIELD -->

            <!-- BEGIN: LOGIN BUTTON -->
            <div
              class="col-lg-12 col-md-12 flex justify-between items-center button-container"
            >
              <div class="pl-3">
                <a
                  class="text-[#28409A] font-medium no-underline"
                  routerLink="/login"
                >
                  Sign in
                </a>
              </div>
              <div class="pr-3">
                <button
                  type="submit"
                  class="bg-[#28409A] text-[#fff] rounded-2xl shadow-lg px-3 py-2 w-24"
                  routerLink="/reset-password"
                >
                  <span class=""> Send Link </span>
                </button>
              </div>
            </div>
            <!-- END: LOGIN BUTTON -->
          </div>
        </div>
      </form>
      <!-- END: FORM -->
    </div>
  </div>
</div>
